import React from "react";
import { BrowserRouter } from "react-router-dom";

import { ReactRouterProvider } from "~/context/reactRouter";
import { useUpdateGlobal } from "~/modules/Common/hooks";

const DesktopRoutes = React.lazy(() => import("~/router/DesktopRoutes"));

function Router() {
  useUpdateGlobal();

  return (
    <BrowserRouter>
      <ReactRouterProvider>
        <React.Suspense fallback={<></>}>{<DesktopRoutes />}</React.Suspense>
      </ReactRouterProvider>
    </BrowserRouter>
  );
}

export default Router;
